module.exports = __webpack_public_path__ + "img/download-banner.71cd89bb.png";